<template>
    <v-container class="pa-2">
        <!-- Images carousel -->
        <v-carousel
            class="mt-8 px-2"
            hide-delimiter-background
            show-arrows-on-hover
            cycle
            height="450px"
            v-model="carousels_page"
        >
            <!-- :show-arrows="false" -->
            <v-carousel-item
                v-for="(src, i) in carouselSrc"
                :key="i"
                :src="src"
                :contain="[0, 1].includes(i)"
            ></v-carousel-item>
        </v-carousel>

        <!-- Header -->
        <v-container class="text-center mt-8 flow-up">
            <h1
                class="font-weight-medium mb-3 primary--text"
                :class="
                    ['sm', 'xs'].includes($vuetify.breakpoint.name)
                        ? 'text-h5'
                        : 'text-h4'
                "
            >
                " {{ $langs.get('home.title') }} "
            </h1>
            <v-btn
                to="/mystore/product"
                class="mt-3 flow-up"
                :class="{ 'text-h6': $vuetify.breakpoint.name != 'xs' }"
                :x-large="$vuetify.breakpoint.name != 'xs'"
                :large="$vuetify.breakpoint.name == 'xs'"
                :ripple="false"
                color="primary"
                rounded
            >
                {{ $langs.get('home.createStore')
                }}<u class="ml-1">{{ $langs.get('home.free') }}!</u>
            </v-btn>
        </v-container>

        <!-- Contest Header -->
        <v-container class="mt-16 text-center text-md-left">
            <v-row class="align-center">
                <v-col cols="12" md="5">
                    <v-img
                        class="mx-auto"
                        style="width: 500px;"
                        src="@/assets/img/image-contest creation.png"
                    ></v-img>
                </v-col>
                <v-col cols="12" md="7" class="mt-8 mt-md-0 mb-8">
                    <h2 class="text-h6 text-sm-h5 text-lg-h4">
                        {{ $langs.get('home.contestTitle1') }}
                    </h2>
                    <h2 class="mt-3 text-h6 text-sm-h5 text-lg-h4">
                        {{ $langs.get('home.contestTitle2') }}
                    </h2>
                    <div
                        class="mt-3 text-caption text-sm-body-2 text-lg-body-1 d-flex align-baseline justify-center justify-md-start"
                    >
                        {{ $langs.get('home.contestContact') }}
                        <v-btn
                            class="px-2 font-weight-light white--text"
                            href="https://www.facebook.com/repttown"
                            target="_blank"
                            plain
                            :ripple="false"
                        >
                            <v-icon x-small class="mr-1"
                                >fab fa-facebook-square</v-icon
                            >
                            Repttown
                        </v-btn>
                    </div>
                    <v-btn
                        :href="contestAppUrl"
                        class="mt-8 black--text"
                        :ripple="false"
                        large
                        rounded
                        color="primary"
                    >
                        {{ $langs.get('home.contestButton') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <FeedbackSection />

        <!-- Main Menus -->
        <v-container class="text-h6 px-4 primary--text">{{
            $langs.get('home.shopCategory')
        }}</v-container>
        <v-row class="mb-16 mx-0">
            <v-col
                v-for="(value, key) in route"
                :key="key"
                class="py-2"
                cols="12"
                :sm="key == 'stores' ? 12 : 6"
                md="4"
            >
                <v-card tile :to="key" :ripple="false" class="pa-3">
                    <v-img
                        eager
                        :src="src[key]"
                        gradient="to right, rgba(50,65,70,.2), rgba(10,0,5,.7)"
                        class="text-right align-center pr-4 white--text text-h4 category-img"
                    >
                        {{ $langs.get(`gen.${key}`) }}
                    </v-img>
                </v-card>
            </v-col>
        </v-row>

        <!-- <div style="position: relative; height: 500px">
            <v-snackbar
                v-for="(n, i) in ['primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning']"
                :key="i"
                :value="true"
                :color="n"
                :style="{ transform: `translateY(${(i) * 60}px)` }"
                :timeout="-1"
                text
                top
                absolute
                min-width="240"
                max-width="380"
            >
                <span class="font-weight-medium">{{ n }}</span>
                <template v-slot:action="{ attrs }">
                    <v-btn
                        dark
                        text
                        v-bind="attrs"
                        :color="n"
                        class="px-1"
                        >{{ $langs.Gen.close[$langs.lang] }}</v-btn
                    >
                </template>
            </v-snackbar>
        </div> -->

        <!-- New Pet arrivals -->
        <template v-if="SHOW_MORE_ITEM">
            <v-container class="text-h6 mt-8">
                NEW PET ARRIVALS
                <router-link class="body-2 ml-3" to="/animals"
                    >SEE ALL</router-link
                >
            </v-container>
            <v-row no-gutters class="align-start justify-center">
                <v-img
                    class="ma-2 hidden-sm-and-down align-end text-center"
                    max-width="calc(100% - 694px)"
                    height="278px"
                    src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg"
                >
                    <v-btn
                        tile
                        x-large
                        depressed
                        :ripple="false"
                        class="mb-3 subtitle-1 black white--text"
                        to="/animals"
                    >
                        SHOP NOW
                    </v-btn>
                </v-img>
                <div style="white-space: nowrap; overflow-x: auto;">
                    <Item
                        v-for="animal in Animals.slice(0, 3)"
                        :key="animal._id"
                        :product="animal"
                        type="animals"
                    />
                </div>
            </v-row>
            <!-- Which category ??? -->
            <v-row no-gutters class="align-start justify-center mt-4">
                <div style="white-space: nowrap; overflow-x: auto;">
                    <Item
                        v-for="animal in Animals.slice(0, 3)"
                        :key="animal._id"
                        :product="animal"
                        type="animals"
                    />
                </div>
                <v-img
                    class="ma-2 hidden-sm-and-down align-end text-center"
                    max-width="calc(100% - 694px)"
                    height="278px"
                    src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg"
                >
                    <v-btn
                        tile
                        depressed
                        x-large
                        :ripple="false"
                        class="mb-3 subtitle-1 black white--text"
                        to="/animals"
                    >
                        SHOP NOW
                    </v-btn>
                </v-img>
            </v-row>
        </template>

        <!-- New Item arrivals -->
        <template v-if="SHOW_MORE_ITEM">
            <v-container class="text-h6 mt-8">
                NEW ITEM ARRIVALS
                <router-link class="body-2 ml-3" to="">SEE ALL</router-link>
            </v-container>
            <v-slide-group class="pa-3" show-arrows>
                <template v-slot:prev="{ on, attrs }">
                    <!-- Left arrow button -->
                    <v-btn
                        text
                        icon
                        :ripple="false"
                        class="mr-4 white"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon large>mdi-chevron-left</v-icon>
                    </v-btn>
                </template>
                <!-- Product Item list -->
                <!-- <v-slide-item v-for="i in Animals.length" :key="i" class="mb-6" v-slot="{}"> -->
                <!-- <Item :product="Animals[i-1]" type="animals"/> -->
                <v-slide-item
                    v-for="animal in Animals"
                    :key="animal._id"
                    class="mb-6"
                    v-slot="{}"
                >
                    <Item :product="animal" type="animals" />
                </v-slide-item>
                <template v-slot:next="{ on, attrs }">
                    <!-- Right arrow button -->
                    <v-btn
                        text
                        icon
                        :ripple="false"
                        class="ml-4 white"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon large>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
            </v-slide-group>
        </template>
    </v-container>
</template>

<script>
// import Item from "@/components/base/Item";
// import ItemList from "@/components/base/ItemList";

// import api from "@/services/api";

import Item from '../../src/components/base/Item'
import ItemList from '../../src/components/base/ItemList'
import FeedbackSection from '@/components/base/FeedbackSection'

import api from '../services/api'
// import { parseProductsList } from "../../src/services/constants";
import { contestAppUrl } from '@/services/constants'

export default {
    components: {
        ItemList,
        Item,
        FeedbackSection
    },
    data() {
        return {
            carousels_page: 0,
            src: {
                logo: require('@/assets/img/S__3686517.jpg'),
                logo2: require('@/assets/img/logo2.png'),
                animals: require('@/assets/img/chameleon-2712355_1920.jpg'),
                petfoods: require('@/assets/img/dog-food-5168940_640.jpg'),
                stores:
                    'https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg',
            },
            carouselSrc: [
                require('@/assets/img/home_new_version_header.png'),
                require('@/assets/img/home_snake_1.jpg'),
                require('@/assets/img/home_snake_2.jpg'),
                require('@/assets/img/home_turtle_1.jpg'),
                require('@/assets/img/home_craig-1.jpg'),
                require('@/assets/img/home_spider_1.jpg'),
                require('@/assets/img/home_verdian_1.jpg'),
            ],
            Animals: [{}, {}, {}],
            Supplies: [],
            route: {
                animals: [],
                petfoods: [],
                stores: [],
            },
            SHOW_MORE_ITEM: false,
            contestAppUrl: contestAppUrl,
        }
    },
    computed: {},
    mounted() {
        // this.loadRoute();
        // this.loadAnimals();
        // this.loadSupplies();
        // console.log(this.$vuetify.breakpoint);
    },
    methods: {
        // async loadRoute() {
        //     let route = await this.$store.dispatch("GetRoute");
        //     this.route = route;
        // },
        // async loadAnimals() {
        //     // parse data from return, then rename to products
        //     let { data: products } = await api.getProducts("animals");
        //     if (!products) return;
        //     // products = parseProductsList(products);
        //     this.Animals = products.slice(0, 15);
        // },
        // async loadSupplies() {
        //     // parse data from return, then rename to products
        //     let { data: products } = await api.getProducts("supplies");
        //     if (!products) return;
        //     // products = parseProductsList(products);
        //     this.Supplies = products.slice(0, 15);
        // },
    },
    metaInfo() {
        return {
            title: 'ซื้อขาย สัตว์เลี้ยง Exotic',
            titleTemplate: '%s · ReptTown',
            // meta: [
            //     {
            //         vmid: "description",
            //         name: "description",
            //         content: "ReptTown",
            //     },
            // ],
        }
    },
}
</script>

<style lang="scss">
// @import "~vuetify/src/styles/styles.sass";

.category-img {
    height: 220px;
    @media #{map-get($display-breakpoints, 'sm-only' )} {
        height: 180px;
    }
    @media #{map-get($display-breakpoints, 'xs-only' )} {
        height: 150px;
    }
}
</style>
